export const LogoMark = ({ className = "h-11 w-auto" }) => (
  <img src="/logo-mark.png" alt="" aria-hidden="true" className={className} />
);

export const Logo = () => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark />
    <div className="leading-none">
      <div className="font-serif text-xl tracking-[0.22em] text-white">TYRELL</div>
      <div className="mt-1 text-[9px] font-medium tracking-[0.38em] text-[#C5A059]">
        PROPERTY SERVICES
      </div>
    </div>
  </div>
);

export const LogoFull = ({ className = "w-48" }) => (
  <img
    src="/logo-full.jpg"
    alt="Tyrell Property Services — Maintenance, Renovations, Refurbishments, Management"
    className={className}
    data-testid="brand-logo-full"
  />
);
